import { Avatar, Box, Typography } from "@mui/material";
import { Trophy } from "../../../../types/types";
import { formatMediaUrl } from "../../../../utils/formatters/formatMedia";
import { TrophyIcon } from "../../assets/icons/player-icons";
import { styles } from "./styles";

interface TrophyCardProps {
  trophy: Trophy;
}

export const TrophyCard = ({ trophy }: TrophyCardProps) => {
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.trophyName}>{trophy.title.name}</Typography>
      <Typography sx={styles.trophyDate}>{trophy.winningDate}</Typography>
      <Box sx={styles.bottomRow}>
        <Avatar src={formatMediaUrl(trophy.experience.team.media?.url)} sx={styles.teamAvatar}>
          {trophy.experience.team.name.slice(0, 2)}
        </Avatar>
        <TrophyIcon />
      </Box>
    </Box>
  );
};
